export type SwipeDirection = "previous" | "next" | null;

interface SwipeCoordinates {
    startX: number;
    startY: number;
    endX: number;
    endY: number;
}

const DEFAULT_SWIPE_THRESHOLD = 48;
const HORIZONTAL_INTENT_RATIO = 1.2;

/**
 * Resolve an intentional horizontal gallery swipe while leaving vertical page
 * scrolling alone. A rightward swipe shows the previous photo; a leftward
 * swipe shows the next photo.
 */
export function getGallerySwipeDirection(
    coordinates: SwipeCoordinates,
    threshold = DEFAULT_SWIPE_THRESHOLD
): SwipeDirection {
    const horizontalDistance = coordinates.endX - coordinates.startX;
    const verticalDistance = coordinates.endY - coordinates.startY;

    if (
        Math.abs(horizontalDistance) < threshold ||
        Math.abs(horizontalDistance) <= Math.abs(verticalDistance) * HORIZONTAL_INTENT_RATIO
    ) {
        return null;
    }

    return horizontalDistance > 0 ? "previous" : "next";
}
